import { luhn } from './luhn'

export function checkPlusgiro(accountNumberString: string) {
  const accountNumber = accountNumberString.replace(/\D/g, '')

  if (accountNumber.length < 2 || accountNumber.length > 8) {
    return false
  }

  return luhn(accountNumber)
}
